/**
 * Cookie Consent Service — Bisson Service
 * Inspiré du service cookieConsent.js
 * Gère le consentement des cookies et le chargement conditionnel des scripts tiers.
 */

const STORAGE_KEY = 'bisson-cookie-consent'

// Instance unique partagée via window
if (!window.__bissonCookieConsent) {
  window.__bissonCookieConsent = {
    registeredScripts: {
      functional:    [],
      analytical:    [],
      performance:   [],
      advertisement: [],
    },
    loadedScripts: {
      functional:    false,
      analytical:    false,
      performance:   false,
      advertisement: false,
    },
  }
}

const state = window.__bissonCookieConsent

/**
 * Retourne le consentement sauvegardé ou null
 */
export function getConsent() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    return saved ? JSON.parse(saved) : null
  } catch {
    return null
  }
}

/**
 * Vérifie si une catégorie est acceptée
 */
export function isAccepted(category) {
  const consent = getConsent()
  if (!consent) return false
  return consent[category] === true
}

/**
 * Initialise le Google Consent Mode par défaut (tout denied)
 */
export function initConsentMode() {
  window.dataLayer = window.dataLayer || []
  function gtag() { window.dataLayer.push(arguments) }
  window.gtag = gtag

  gtag('consent', 'default', {
    analytics_storage:    'denied',
    ad_storage:           'denied',
    ad_user_data:         'denied',
    ad_personalization:   'denied',
    functionality_storage:'denied',
    personalization_storage: 'denied',
    security_storage:     'granted',
  })

  const consent = getConsent()
  if (consent) updateGoogleConsent(consent)
}

/**
 * Met à jour le Google Consent Mode dynamiquement
 */
function updateGoogleConsent(consent) {
  if (!window.gtag) return
  window.gtag('consent', 'update', {
    analytics_storage:      consent.analytical    ? 'granted' : 'denied',
    ad_storage:             consent.advertisement ? 'granted' : 'denied',
    ad_user_data:           consent.advertisement ? 'granted' : 'denied',
    ad_personalization:     consent.advertisement ? 'granted' : 'denied',
    functionality_storage:  consent.functional    ? 'granted' : 'denied',
    personalization_storage:consent.performance   ? 'granted' : 'denied',
  })
}

/**
 * Enregistre une fonction à exécuter quand une catégorie est acceptée
 */
export function registerScript(category, loadFn) {
  if (!state.registeredScripts[category]) {
    console.warn(`[BissonCookieConsent] Catégorie inconnue : ${category}`)
    return
  }
  state.registeredScripts[category].push(loadFn)
}

/**
 * Charge les scripts d'une catégorie si pas déjà chargés
 */
function loadCategoryScripts(category) {
  if (state.loadedScripts[category]) return
  state.registeredScripts[category].forEach(fn => {
    try { fn() } catch (err) {
      console.error(`[BissonCookieConsent] Erreur (${category}):`, err)
    }
  })
  state.loadedScripts[category] = true
}

/**
 * Met à jour le consentement — appelé depuis CookieBanner
 */
export function updateConsent(consent) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent))
  updateGoogleConsent(consent)
  ;['functional', 'analytical', 'performance', 'advertisement'].forEach(cat => {
    if (consent[cat]) loadCategoryScripts(cat)
  })
}

/**
 * Applique le consentement sauvegardé — appelé au mounted de App.vue
 */
export function applyConsent() {
  const consent = getConsent()
  if (!consent) return
  ;['functional', 'analytical', 'performance', 'advertisement'].forEach(cat => {
    if (consent[cat]) loadCategoryScripts(cat)
  })
}

/**
 * Réinitialise tout le consentement
 */
export function resetConsent() {
  localStorage.removeItem(STORAGE_KEY)
  Object.keys(state.loadedScripts).forEach(key => { state.loadedScripts[key] = false })
}
